export default __webpack_public_path__ + "static/media/242.a01a4a95.jpg";